<template lang="pug">
.d-flex.flex-column.gap-16(v-if="items.length")
  p.ui-body-1.font-weight-medium Заявки на смену электронной почты
  .d-flex.align-center.justify-space-between(v-for="item in items" :key="item.id")
    .d-flex.flex-column.gap-8
      .d-flex.flex-wrap.align-center.gap-8.ui-body-2
        span.opacity-70 {{ item.old || 'Не указана' }}
        v-icon(:size="16") $ui-arrow-right
        span {{ item.new }}
      p.ui-body-2.ui-success--text(v-if="item.change_at") Почта изменится {{ item.change_at | readableDateWithTime }}
      p.ui-body-2.ui-warning--text.text--darken-1(v-else) Ожидает подтверждения
    .d-flex.flex-wrap.gap-8
      dv-tooltip(v-if="!item.change_at" text="Подтвердить")
        dv-btn(small icon :disabled="busy || !!removalDialogId" @click="$emit('confirm', item)"): v-icon(:size="20") $ui-check
      dv-tooltip(v-if="item.id != null" text="Отменить")
        dv-btn(small icon color="ui-error" :disabled="busy || !!removalDialogId" @click="confirmRemoval(item)"): v-icon(:size="20") $ui-delete
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import { localeFormat } from '@/plugins/date-print';
import getApiErrorMessage from '@/helpers/getApiErrorMessage';
import DvTooltip from '@/packages/ui/components/tooltips/DvTooltip.vue';

export default {
  components: { DvBtn, DvTooltip },
  filters: { readableDateWithTime: localeFormat },
  props: {
    items: { type: Array, default: () => [] },
    busy: { type: Boolean, default: false },
    removeMethod: { type: Function, required: true },
    isActive: { type: Function, default: () => true },
  },
  data: () => ({ removalDialogId: undefined, removing: false, disposed: false }),
  beforeDestroy() {
    this.disposed = true;
    if (this.removalDialogId) this.$dialogs.close(this.removalDialogId);
  },
  methods: {
    active() { return !this.disposed && this.isActive(); },
    confirmRemoval(item) {
      if (!this.active() || this.busy || item.id == null || (this.removalDialogId && this.$dialogs.has(this.removalDialogId))) return;
      this.removalDialogId = this.$dialogs.confirm({
        attrs: {
          title: 'Отменить смену электронной почты?',
          message: `Заявка на смену почты на ${item.new} будет удалена.`,
          isRequest: true,
          method: async () => {
            if (!this.active() || this.removing || !this.items.some(({ id }) => id === item.id)) return { error: new Error('Операция отменена.') };
            this.removing = true;
            try {
              const result = await this.removeMethod({ args: [item.id], isActive: this.active });
              if (result.error && this.active()) this.$toast.error(getApiErrorMessage(result.error));
              return result;
            } catch (error) {
              if (this.active()) this.$toast.error(getApiErrorMessage(error));
              return { error };
            } finally {
              this.removing = false;
            }
          },
          successCallback: () => {
            if (!this.active()) return;
            this.$emit('removed', item.id);
            this.$toast.success('Заявка на смену почты отменена');
          },
          confirmBtnAttrs: { 'btn-text': 'Отменить заявку', color: 'ui-primary', large: true, class: 'flex-1 rounded-12 ui-body-1' },
          closeBtnAttrs: { 'btn-text': 'Закрыть', color: 'ui-primary', large: true, class: 'flex-1 rounded-12 ui-body-1' },
        },
        listeners: { close: () => { this.removalDialogId = undefined; } },
      });
    },
  },
};
</script>
